import { Product } from '../product/Product'
import { Prop } from '@typegoose/typegoose'
import { Field, ID, Float, ObjectType, InputType } from 'type-graphql'
import { RelatedEntity } from '../base/RelatedEntity'
import { InventoryBySerialNumber } from '../inventorybyserialnumber/InventoryBySerialNumber'
import { generateEntityId } from '../generateEntityId'
import { UnitOfMeasure } from '../unitOfMeasure/UnitOfMeasure'

@ObjectType()
@InputType('OrderItemInput')
export class OrderItem {
  @Field(() => ID)
  @Prop({ type: String, required: true, default: () => generateEntityId('orit') })
  _id: string

  @Field(() => Product)
  @Prop({ type: () => RelatedEntity })
  product: ReturnType<() => Product>

  @Field(() => Float)
  @Prop({ type: Number })
  quantity: number

  @Field(() => Float)
  @Prop({ type: Number })
  price: number

  @Field(() => Float)
  @Prop({ type: Number })
  net: number

  @Field(() => Float)
  @Prop({ type: Number })
  gross: number

  @Field(() => Float)
  @Prop({ type: Number })
  discount: number //amount to be discounted, not percent

  @Field(() => Float)
  @Prop({ type: Number })
  originalPrice: number

  @Field(() => String)
  @Prop({ type: String })
  remarks: string

  @Field(() => [String])
  @Prop({ type: [String] })
  tags: string[]

  @Field(() => [InventoryBySerialNumber])
  @Prop({ type: [String] })
  serialNumbers: string[]

  //This has field resolver, but we put it here for type-safety too
  @Field(() => Float)
  shippingWeight: number

  /**
   * Snapshot of the product's order UOM at add-to-cart time.
   * Contains embedded fields: _id, code, name, symbol
   */
  @Field(() => UnitOfMeasure, { nullable: true })
  @Prop({ type: () => UnitOfMeasure })
  uom?: ReturnType<() => UnitOfMeasure>
}
